import { useRef, useLayoutEffect } from "react";
import gsap from "gsap";
const Header = () => {
  const titleRef = useRef(null);
  useLayoutEffect(() => {
    gsap.from(titleRef.current, {
      y: 50,
      opacity: 0,
      duration: 1,
      ease: "power3.out"
    });
  }, []);
  return <div ref={titleRef} className="text-center mb-8 md:mb-10 pt-6 md:pt-10">
      <h1 className="text-3xl md:text-5xl lg:text-7xl mb-4 md:mb-6 font-medium px-4 md:px-0">Un problema reale</h1>
      <p className="text-base md:text-xl text-gray-600 max-w-8xl mx-auto mb-12 md:mb-20 px-4 md:px-8 font-light leading-relaxed lg:text-2xl">Il processo di assunzione tradizionale è obsoleto</p>
    </div>;
};
export default Header;